export default __webpack_public_path__ + "26ebffbec7f7766b7259cd1235df0c3e.png";